// import React, { useState, useEffect } from 'react';
// import { Sun, Battery, Zap, Package, Cable, ChevronRight, Star, Users, ShoppingCart, Search, Building, Truck, CreditCard } from 'lucide-react';
// import Header from '../components/Header';
// import HeroSection from '../components/HeroSection';
// import ServicesAndBrands from './ServicesPage';
// import bannerImg from '../assets/house-with-solar-panels-sorting-litter-bins_107791-2094.jpg'

// const HomePage = () => {
//   const [activeCategory, setActiveCategory] = useState('SOLAR PANELS');
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [searchFocused, setSearchFocused] = useState(false);
//   const [cartCount, setCartCount] = useState(0);
//   const services = [
//     {
//       title: "Wholesale",
//       icon: <Building className="w-12 h-12 text-green-600" />,
//       description: "With warehouses based all over Australia, Sol Mart can distribute Solar PV components, electrical cables & consumables anywhere in the country. Our wholesale products come with a High-Performance Warranty and are highly recommended by industry leaders."
//     },
//     {
//       title: "Freight",
//       icon: <Truck className="w-12 h-12 text-green-600" />,
//       description: "Sol Mart's freight services deliver all over Australia so you can sit back and relax as you await your stock. We even offer same day delivery depending on your location."
//     },
//     {
//       title: "STC Trading",
//       icon: <CreditCard className="w-12 h-12 text-green-600" />,
//       description: "You can now trade your STCs with us digitally, benefiting from our streamlined Solar Panel Validation (SPV) process. We utilize a trusted platform to simplify the SPV application, allowing you to trade your STCs with ease. With just a few quick clicks from your phone, you can complete your transactions efficiently and stress-free."
//     }
//   ];

//   const brands = [
//     { id: 1, name: "Brand 1", logo: "/api/placeholder/180/60" },
//     { id: 2, name: "Brand 2", logo: "/api/placeholder/180/60" },
//     { id: 3, name: "Brand 3", logo: "/api/placeholder/180/60" },
//     { id: 4, name: "Brand 4", logo: "/api/placeholder/180/60" },
//     { id: 5, name: "Brand 5", logo: "/api/placeholder/180/60" },
//     { id: 6, name: "Brand 6", logo: "/api/placeholder/180/60" }
//   ];
//   useEffect(() => {
//     const handleScroll = () => {
//       setIsScrolled(window.scrollY > 20);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const categories = [
//     { name: 'SOLAR PANELS', icon: <Sun className="w-12 h-12 mb-2" />, products: 24 },
//     { name: 'SOLAR INVERTERS', icon: <Zap className="w-12 h-12 mb-2" />, products: 18 },
//     { name: 'SOLAR BATTERY', icon: <Battery className="w-12 h-12 mb-2" />, products: 12 },
//     { name: 'MOUNTING KITS', icon: <Package className="w-12 h-12 mb-2" />, products: 15 },
//     { name: 'ELECTRICALS', icon: <Cable className="w-12 h-12 mb-2" />, products: 30 },
//   ];

//   const featuredProducts = [
//     { id: 1, name: 'Premium Solar Panel Kit', price: 599, rating: 4.8, reviews: 127 },
//     { id: 2, name: 'Smart Inverter Pro', price: 899, rating: 4.9, reviews: 89 },
//     { id: 3, name: 'Energy Storage System', price: 1299, rating: 4.7, reviews: 156 },
//   ];

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Enhanced Header */}
  
//    <header className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white/40 backdrop-blur-md border border-white/20'}`}>
      
//     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//       <div className="flex justify-between items-center h-20">
//         <div className="flex items-center space-x-16">
//           <h1 className="text-2xl font-bold text-green-600">SOLmart</h1>
//           <div className="hidden md:flex space-x-8">
//             {['Home', 'Products', 'Solutions', 'About Us'].map((item) => (
//               <button key={item} className="text-gray-700 hover:text-green-600 transition-colors">
//                 {item}
//               </button>
//             ))}
//           </div>
//         </div>

//         <div className="flex items-center space-x-6">
//           <div className={`relative transition-all duration-300 ${searchFocused ? 'w-64' : 'w-48'}`}>
//             <input
//               type="text"
//               placeholder="Search products..."
//               className="w-full px-4 py-2 rounded-full bg-gray-100 focus:bg-white focus:ring-2 focus:ring-green-500 transition-all"
//               onFocus={() => setSearchFocused(true)}
//               onBlur={() => setSearchFocused(false)}
//             />
//             <Search className="absolute right-3 top-2.5 h-5 w-5 text-gray-400" />
//           </div>
          
//           <button className="relative">
//             <ShoppingCart className="h-6 w-6 text-gray-700 hover:text-green-600 transition-colors" />
//             {cartCount > 0 && (
//               <span className="absolute -top-2 -right-2 bg-green-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
//                 {cartCount}
//               </span>
//             )}
//           </button>
//         </div>
//       </div>
//     </div>
//   </header>

//       {/* Hero Section */}
//       <div className="pt-20 bg-gradient-to-br from-green-50 via-white to-emerald-50">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
//           <div className="space-y-8">
//             <h2 className="text-5xl font-bold text-gray-900 leading-tight">
//               Power Your Home with <span className="text-green-600">Solar Energy</span> Solutions
//             </h2>
//             <p className="text-xl text-gray-600">
//               Transform your energy consumption with our premium solar products. Save money while saving the planet.
//             </p>
//             <div className="flex space-x-4">
//               <button 
//                 className="px-8 py-4 bg-green-600 text-white rounded-lg hover:bg-green-700 transform hover:scale-105 transition-all"
//                 onClick={() => setCartCount(prev => prev + 1)}
//               >
//                 Shop Now
//               </button>
//               <button className="px-8 py-4 border-2 border-green-600 text-green-600 rounded-lg hover:bg-green-50 transition-all">
//                 Learn More
//               </button>
//             </div>
//           </div>
//           <div className="relative">
//             <img
//               src={bannerImg}
//               alt="Solar Installation"
//               className="rounded-2xl shadow-2xl transform hover:scale-105 transition-all duration-500"
//             />
//             <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-xl shadow-lg">
//               <div className="flex items-center space-x-2">
//                 <Users className="h-5 w-5 text-green-600" />
//                 <span className="text-sm font-medium">1000+ Happy Customers</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div> 

//       {/* Categories */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 bg-primary-">
//         <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
//           {categories.map((category) => (
//             <button
//               key={category.name}
//               onClick={() => setActiveCategory(category.name)}
//               className={`flex flex-col items-center justify-center p-6 rounded-xl transition-all duration-300 transform hover:scale-105 ${
//                 activeCategory === category.name
//                   ? 'bg-green-600 text-white shadow-lg'
//                   : 'bg-white text-gray-600 hover:shadow-md'
//               }`}
//             >
//               {category.icon}
//               <span className="text-sm font-medium text-center mb-2">{category.name}</span>
//               <span className="text-xs opacity-75">{category.products} Products</span>
//             </button>
//           ))}
//         </div>
//       </div>

//           {/* Services Section */}
//       <section className="py-16 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-12">
//             <h2 className="text-4xl font-bold text-gray-900 mb-4">OUR SERVICES</h2>
//             <p className="text-lg text-gray-600 max-w-3xl mx-auto">
//               Solmart is a rapidly expanding nation wide wholesaler specializing in a broad spectrum of renewable energy and energy efficiency products.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {services.map((service, index) => (
//               <div 
//                 key={index}
//                 className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
//               >
//                 <div className="flex flex-col items-center text-center">
//                   <div className="mb-4 p-3 bg-green-50 rounded-full">
//                     {service.icon}
//                   </div>
//                   <h3 className="text-xl font-semibold text-gray-900 mb-4">
//                     {service.title}
//                   </h3>
//                   <p className="text-gray-600">
//                     {service.description}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Brands Section */}
//       <section className="py-16 bg-gray-900 relative overflow-hidden">
//         <div className="absolute inset-0 opacity-10">
//           <div className="absolute inset-0 bg-gradient-to-br from-green-500 to-green-800"></div>
//         </div>
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
//           <div className="text-center mb-12">
//             <h2 className="text-4xl font-bold text-white mb-4">BRANDS WE SELL</h2>
//             <p className="text-lg text-gray-300">
//               We partner with industry-leading manufacturers to bring you the best solar solutions
//             </p>
//           </div>

//           <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
//             {brands.map((brand) => (
//               <div 
//                 key={brand.id}
//                 className="bg-white rounded-lg p-6 flex items-center justify-center transform hover:scale-105 transition-transform duration-300"
//               >
//                 <img
//                   src={brand.logo}
//                   alt={brand.name}
//                   className="max-h-12 w-auto"
//                 />
//               </div>
//             ))}
//           </div>

//           <div className="mt-12 text-center">
//             <button className="inline-flex items-center px-6 py-3 border-2 border-green-500 text-green-500 hover:bg-green-500 hover:text-white rounded-lg transition-colors duration-300">
//               View All Brands
//             </button>
//           </div>
//         </div>
//       </section>


//       {/* Featured Products */}
//       <div className="bg-white py-16">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <h3 className="text-2xl font-bold text-gray-900 mb-8">Featured Products</h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {featuredProducts.map((product) => (
//               <div
//                 key={product.id}
//                 className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-shadow"
//               >
//                 <div className="relative mb-4">
//                   <img
//                     src="/api/placeholder/300/200"
//                     alt={product.name}
//                     className="w-full h-48 object-cover rounded-lg"
//                   />
//                   <button 
//                     className="absolute top-2 right-2 p-2 bg-white rounded-full shadow-md hover:bg-green-50 transition-colors"
//                     onClick={() => setCartCount(prev => prev + 1)}
//                   >
//                     <ShoppingCart className="h-5 w-5 text-green-600" />
//                   </button>
//                 </div>
//                 <h4 className="text-lg font-semibold text-gray-900 mb-2">{product.name}</h4>
//                 <div className="flex items-center justify-between mb-4">
//                   <span className="text-2xl font-bold text-green-600">${product.price}</span>
//                   <div className="flex items-center">
//                     <Star className="h-5 w-5 text-green-500 fill-current" />
//                     <span className="ml-1 text-sm text-gray-600">{product.rating}</span>
//                     <span className="ml-1 text-xs text-gray-400">({product.reviews})</span>
//                   </div>
//                 </div>
//                 <button 
//                   className="w-full py-2 bg-green-100 text-green-600 rounded-lg hover:bg-green-200 transition-colors"
//                   onClick={() => setCartCount(prev => prev + 1)}
//                 >
//                   Add to Cart
//                 </button>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HomePage;

// // import React, { useState, useEffect } from 'react';
// // import { Sun, Battery, Zap, Package, Cable, ChevronRight, Star, Users, ShoppingCart, Search } from 'lucide-react';

// // const HomePage = () => {
// //   // ... existing state logic ...
// //   const [activeCategory, setActiveCategory] = useState('SOLAR PANELS');
// //   const [isScrolled, setIsScrolled] = useState(false);
// //   const [searchFocused, setSearchFocused] = useState(false);
// //   const [cartCount, setCartCount] = useState(0);

// //   useEffect(() => {
// //     const handleScroll = () => {
// //       setIsScrolled(window.scrollY > 20);
// //     };
// //     window.addEventListener('scroll', handleScroll);
// //     return () => window.removeEventListener('scroll', handleScroll);
// //   }, []);

// //   const categories = [
// //     { name: 'SOLAR PANELS', icon: <Sun className="w-12 h-12 mb-2" />, products: 24 },
// //     { name: 'SOLAR INVERTERS', icon: <Zap className="w-12 h-12 mb-2" />, products: 18 },
// //     { name: 'SOLAR BATTERY', icon: <Battery className="w-12 h-12 mb-2" />, products: 12 },
// //     { name: 'MOUNTING KITS', icon: <Package className="w-12 h-12 mb-2" />, products: 15 },
// //     { name: 'ELECTRICALS', icon: <Cable className="w-12 h-12 mb-2" />, products: 30 },
// //   ];

// //   const featuredProducts = [
// //     { id: 1, name: 'Premium Solar Panel Kit', price: 599, rating: 4.8, reviews: 127 },
// //     { id: 2, name: 'Smart Inverter Pro', price: 899, rating: 4.9, reviews: 89 },
// //     { id: 3, name: 'Energy Storage System', price: 1299, rating: 4.7, reviews: 156 },
// //   ];


// //   // Updated color palette
// //   const colors = {
// //     primary: 'hsl(164, 60%, 40%)',       // Sophisticated teal-green
// //     secondary: 'hsl(42, 90%, 55%)',      // Warm accent yellow
// //     background: 'hsl(210, 38%, 97%)',    // Light airy background
// //     dark: 'hsl(210, 24%, 16%)',          // Dark text
// //     light: 'hsl(0, 0%, 100%)'           // Pure white
// //   };

// //   return (
// //     <div className="min-h-screen" style={{ backgroundColor: colors.background }}>
// //       {/* Enhanced Header with better typography */}
// //       <header className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'} font-['Inter']`}>
// //         <div className="max-w-8xl mx-auto px-6 py-4">
// //           <div className="flex justify-between items-center">
// //             <h1 className="text-3xl font-bold tracking-tighter" style={{ color: colors.primary }}>
// //               SOL<span className="font-light">mart</span>
// //             </h1>
            
// //             <nav className="hidden lg:flex space-x-10">
// //               {['Home', 'Products', 'Solutions', 'About'].map((item) => (
// //                 <button 
// //                   key={item} 
// //                   className="relative text-lg font-medium hover:text-green-800 transition-colors"
// //                   style={{ color: colors.dark }}
// //                 >
// //                   {item}
// //                   <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-green-600 transition-all group-hover:w-full"></span>
// //                 </button>
// //               ))}
// //             </nav>

// //             <div className="flex items-center space-x-6">
// //               <div className={`relative transition-all duration-300 ${searchFocused ? 'w-72' : 'w-56'}`}>
// //                 <input
// //                   type="text"
// //                   placeholder="Search..."
// //                   className="w-full px-5 py-3 rounded-full border-0 shadow-sm focus:ring-2 focus:ring-green-500/50 transition-all"
// //                   style={{ backgroundColor: colors.light }}
// //                   onFocus={() => setSearchFocused(true)}
// //                   onBlur={() => setSearchFocused(false)}
// //                 />
// //                 <Search className="absolute right-4 top-3.5 h-5 w-5 text-gray-400" />
// //               </div>
              
// //               <button className="relative p-2 hover:bg-green-100/50 rounded-full transition-colors">
// //                 <ShoppingCart className="h-6 w-6" style={{ color: colors.dark }} />
// //                 {cartCount > 0 && (
// //                   <span 
// //                     className="absolute -top-1 -right-1 bg-green-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center shadow-sm"
// //                     style={{ backgroundColor: colors.primary }}
// //                   >
// //                     {cartCount}
// //                   </span>
// //                 )}
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       </header>

// //       {/* Modern Hero Section */}
// //       <div className="pt-32 pb-24 relative overflow-hidden">
// //         <div className="max-w-8xl mx-auto px-6">
// //           <div className="grid lg:grid-cols-2 gap-16 items-center">
// //             <div className="space-y-8 z-10">
// //               <h1 className="text-6xl font-bold tracking-tight leading-[1.15]" style={{ color: colors.dark }}>
// //                 Sustainable Energy
// //                 <span className="block mt-4 bg-gradient-to-r from-green-600 to-emerald-500 bg-clip-text text-transparent">
// //                   Made Accessible
// //                 </span>
// //               </h1>
// //               <p className="text-xl font-medium text-gray-600 leading-relaxed">
// //                 Premium solar solutions meeting modern energy needs. 
// //                 <span className="block mt-2">Reduce bills · Increase value · Protect future</span>
// //               </p>
              
// //               <div className="flex space-x-5">
// //                 <button
// //                   className="px-8 py-4 rounded-xl font-semibold text-white shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5"
// //                   style={{ 
// //                     backgroundColor: colors.primary,
// //                     backgroundImage: 'linear-gradient(to right, hsl(164, 60%, 40%), hsl(164, 60%, 35%))'
// //                   }}
// //                 >
// //                   Explore Products
// //                 </button>
// //                 <button
// //                   className="px-8 py-4 rounded-xl border-2 font-semibold transition-all duration-300 hover:bg-green-50/50"
// //                   style={{ 
// //                     borderColor: colors.primary,
// //                     color: colors.primary
// //                   }}
// //                 >
// //                   Watch Demo
// //                 </button>
// //               </div>
// //             </div>

// //             <div className="relative rounded-3xl overflow-hidden shadow-2xl transform hover:scale-[1.01] transition-transform duration-500">
// //               <img
// //                 src={bannerImg}
// //                 alt="Solar Panels"
// //                 className="w-full h-[600px] object-cover"
// //               />
// //               <div 
// //                 className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-green-900/80 to-transparent"
// //                 style={{ color: colors.light }}
// //               >
// //                 <div className="flex justify-between items-end">
// //                   <div>
// //                     <h3 className="text-2xl font-bold mb-2">Smart Home Energy</h3>
// //                     <p className="opacity-90">Complete residential solutions</p>
// //                   </div>
// //                   <div className="flex items-center space-x-2">
// //                     <Users className="h-5 w-5" />
// //                     <span>1,200+ Installations</span>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Modern Category Cards */}
// //       <div className="max-w-8xl mx-auto px-6 py-20">
// //         <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
// //           {categories.map((category) => (
// //             <div
// //               key={category.name}
// //               className="relative group overflow-hidden rounded-2xl bg-white shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer"
// //               onClick={() => setActiveCategory(category.name)}
// //             >
// //               <div className={`p-8 transition-colors duration-300 ${activeCategory === category.name ? 'bg-green-50' : 'bg-white'}`}>
// //                 <div className="mb-6 text-green-600">{category.icon}</div>
// //                 <h3 className="text-xl font-semibold mb-2 text-gray-900">{category.name}</h3>
// //                 <p className="text-sm text-gray-500">{category.products} products available</p>
// //               </div>
// //               <div className={`absolute bottom-0 left-0 right-0 h-1 transition-all duration-300 ${activeCategory === category.name ? 'bg-green-600' : 'bg-transparent'}`} />
// //             </div>
// //           ))}
// //         </div>
// //       </div>

// //       {/* Enhanced Product Cards */}
// //       <div className="max-w-8xl mx-auto px-6 py-20">
// //         <h3 className="text-3xl font-bold mb-12 text-gray-900">Featured Solutions</h3>
// //         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
// //           {featuredProducts.map((product) => (
// //             <div
// //               key={product.id}
// //               className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden"
// //             >
// //               <div className="relative h-72 overflow-hidden">
// //                 <img
// //                   src="/api/placeholder/300/200"
// //                   alt={product.name}
// //                   className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300"
// //                 />
// //                 <div className="absolute inset-0 bg-gradient-to-t from-green-900/30 to-transparent" />
// //               </div>
              
// //               <div className="p-6">
// //                 <div className="flex justify-between items-start mb-4">
// //                   <h4 className="text-xl font-semibold text-gray-900">{product.name}</h4>
// //                   <button 
// //                     className="p-2 bg-white/90 backdrop-blur rounded-full shadow-sm hover:bg-green-100 transition-colors"
// //                     onClick={() => setCartCount(prev => prev + 1)}
// //                   >
// //                     <ShoppingCart className="h-5 w-5 text-green-600" />
// //                   </button>
// //                 </div>
                
// //                 <div className="flex justify-between items-center">
// //                   <span className="text-2xl font-bold" style={{ color: colors.primary }}>
// //                     ${product.price}
// //                   </span>
// //                   <div className="flex items-center space-x-1">
// //                     <Star className="h-5 w-5 text-amber-400 fill-current" />
// //                     <span className="font-medium">{product.rating}</span>
// //                     <span className="text-gray-500">({product.reviews})</span>
// //                   </div>
// //                 </div>
                
// //                 <button
// //                   className="w-full mt-4 py-3 rounded-lg bg-green-50 text-green-700 font-medium hover:bg-green-100 transition-colors"
// //                   onClick={() => setCartCount(prev => prev + 1)}
// //                 >
// //                   Configure System
// //                 </button>
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default HomePage;




import React, { useState, useEffect, useMemo } from 'react';
import { Sun, Battery, Zap, Package, Cable, ChevronRight, Star, Users, ShoppingCart, Search, Building, Truck, CreditCard, Phone, Mail, Clock } from 'lucide-react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ServicesAndBrands from './ServicesPage';
import bannerImg from '../assets/house-with-solar-panels-sorting-litter-bins_107791-2094.jpg'
import { motion, AnimatePresence } from 'framer-motion';
import Footer from '../components/Footer';
import logo from '../assets/klogo2.png'
import ja from '../assets/ja.png'
import jinko from '../assets/jinko.png'
import trina from '../assets/download.png'
import longi from '../assets/longi.png'
import rec from '../assets/rec.png'
import canadian from '../assets/canadian.png'
import astro from '../assets/astron.jpeg'
import solis from '../assets/solis.png'
import goodwe from '../assets/goodwe.png'
import sungrow from '../assets/sungroq.png'
import fronius from '../assets/fronius.png'
import antai from '../assets/antai.jpeg'
import mibet from '../assets/mibet.jpeg'
import ContactPage from '../components/Contact';
const HomePage = () => {
  const [activeCategory, setActiveCategory] = useState('SOLAR PANELS');
  const [isScrolled, setIsScrolled] = useState(false);
  const [searchFocused, setSearchFocused] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const defaultServices = [
    {
      title: "Wholesale",
      icon: <Building className="w-12 h-12 text-green-600" />,
      description: "With warehouses based all over Australia, Sol Mart can distribute Solar PV components, electrical cables & consumables anywhere in the country. Our wholesale products come with a High-Performance Warranty and are highly recommended by industry leaders."
    },
    {
      title: "Freight",
      icon: <Truck className="w-12 h-12 text-green-600" />,
      description: "Sol Mart's freight services deliver all over Australia so you can sit back and relax as you await your stock. We even offer same day delivery depending on your location."
    },
    {
      title: "STC Trading",
      icon: <CreditCard className="w-12 h-12 text-green-600" />,
      description: "You can now trade your STCs with us digitally, benefiting from our streamlined Solar Panel Validation (SPV) process. We utilize a trusted platform to simplify the SPV application, allowing you to trade your STCs with ease. With just a few quick clicks from your phone, you can complete your transactions efficiently and stress-free."
    }
  ];

  const defaultBrands = [
    { id: 1, name: "Brand 1", logo: "/api/placeholder/180/60" },
    { id: 2, name: "Brand 2", logo: "/api/placeholder/180/60" },
    { id: 3, name: "Brand 3", logo: "/api/placeholder/180/60" },
    { id: 4, name: "Brand 4", logo: "/api/placeholder/180/60" },
    { id: 5, name: "Brand 5", logo: "/api/placeholder/180/60" },
    { id: 6, name: "Brand 6", logo: "/api/placeholder/180/60" }
  ];
  const businessHours = [
    { day: "Monday - Friday", hours: "8:30 AM - 5:00 PM" },
    
  ];
  // Updated categories with category-specific content
  const categories = [
    { 
      name: 'SOLAR PANELS',
      icon: <Sun className="w-12 h-12 mb-2" />,
      products: 24,
      services: [
        {
          title: "Premium Solar Panels",
          icon: <Sun className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Inverters",
          icon: <Zap className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Panels",
          icon: <Battery className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Panels",
          icon: <Package className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Panels",
          icon: <Cable className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        // ... other solar panel services
      ],
      brands: [
        { id: 1, name: "SolarTech", logo: "/solar-panel-brand1.png" },
        // ... other solar panel brands
      ]
    },

    { 
      name: 'SOLAR INVERTERS',
      icon: <Zap className="w-12 h-12 mb-2" />,
      products: 24,
      services: [
        {
          title: "Premium Solar Panels",
          icon: <Sun className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Inverters",
          icon: <Zap className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Panels",
          icon: <Battery className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Panels",
          icon: <Package className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Panels",
          icon: <Cable className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        // ... other solar panel services
      ],
      brands: [
        { id: 1, name: "SolarTech", logo: "/solar-panel-brand1.png" },
        // ... other solar panel brands
      ]
    },

    { 
      name: 'SOLAR BATTERY',
      icon: <Battery className="w-12 h-12 mb-2" />,
      products: 24,
      services: [
        {
          title: "Premium Solar Panels",
          icon: <Sun className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Inverters",
          icon: <Zap className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Panels",
          icon: <Battery className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Panels",
          icon: <Package className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Panels",
          icon: <Cable className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        // ... other solar panel services
      ],
      brands: [
        { id: 1, name: "SolarTech", logo: "/solar-panel-brand1.png" },
        // ... other solar panel brands
      ]
    },

    { 
      name: 'MOUNTING KIT',
      icon: <Package className="w-12 h-12 mb-2" />,
      products: 24,
      services: [
        {
          title: "Premium Solar Panels",
          icon: <Sun className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Inverters",
          icon: <Zap className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Panels",
          icon: <Battery className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Panels",
          icon: <Package className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Panels",
          icon: <Cable className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        // ... other solar panel services
      ],
      brands: [
        { id: 1, name: "SolarTech", logo: "/solar-panel-brand1.png" },
        // ... other solar panel brands
      ]
    },
    { 
      name: 'ELECTRICAL',
      icon: <Cable className="w-12 h-12 mb-2" />,
      products: 24,
      services: [
        {
          title: "Premium Solar Panels",
          icon: <Sun className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Inverters",
          icon: <Zap className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Panels",
          icon: <Battery className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Panels",
          icon: <Package className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        {
          title: "Premium Solar Panels",
          icon: <Cable className="w-12 h-12 text-green-600" />,
          description: "High-efficiency solar panels with 25-year warranty..."
        },
        // ... other solar panel services
      ],
      brands: [
        { id: 1, name: "SolarTech", logo: "/solar-panel-brand1.png" },
        // ... other solar panel brands
      ]
    },
    // ... other categories with their own services and brands
  ];

  // Memoized current content based on active category
  const { servicesToDisplay, brandsToDisplay } = useMemo(() => {
    const selectedCategory = categories.find(cat => cat.name === activeCategory);
    return {
      servicesToDisplay: selectedCategory ? selectedCategory.services : defaultServices,
      brandsToDisplay: selectedCategory ? selectedCategory.brands : defaultBrands
    };
  }, [activeCategory]);

  // Animation variants
  const fadeInVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 }
  };

  const services = [
    {
      title: "Wholesale",
      icon: <Building className="w-12 h-12 text-green-600" />,
      description: "With warehouses based all over Australia, Sol Mart can distribute Solar PV components, electrical cables & consumables anywhere in the country. Our wholesale products come with a High-Performance Warranty and are highly recommended by industry leaders."
    },
    {
      title: "Freight",
      icon: <Truck className="w-12 h-12 text-green-600" />,
      description: "Sol Mart's freight services deliver all over Australia so you can sit back and relax as you await your stock. We even offer same day delivery depending on your location."
    },
    {
      title: "STC Trading",
      icon: <CreditCard className="w-12 h-12 text-green-600" />,
      description: "You can now trade your STCs with us digitally, benefiting from our streamlined Solar Panel Validation (SPV) process. We utilize a trusted platform to simplify the SPV application, allowing you to trade your STCs with ease. With just a few quick clicks from your phone, you can complete your transactions efficiently and stress-free."
    }
  ];

  const brands = [
    { id: 1, name: "Brand 1", logo: "/api/placeholder/180/60" },
    { id: 2, name: "Brand 2", logo: "/api/placeholder/180/60" },
    { id: 3, name: "Brand 3", logo: "/api/placeholder/180/60" },
    { id: 4, name: "Brand 4", logo: "/api/placeholder/180/60" },
    { id: 5, name: "Brand 5", logo: "/api/placeholder/180/60" },
    { id: 6, name: "Brand 6", logo: "/api/placeholder/180/60" }
  ];
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // const categories = [
  //   { name: 'SOLAR PANELS', icon: <Sun className="w-12 h-12 mb-2" />, products: 24 },
  //   { name: 'SOLAR INVERTERS', icon: <Zap className="w-12 h-12 mb-2" />, products: 18 },
  //   { name: 'SOLAR BATTERY', icon: <Battery className="w-12 h-12 mb-2" />, products: 12 },
  //   { name: 'MOUNTING KITS', icon: <Package className="w-12 h-12 mb-2" />, products: 15 },
  //   { name: 'ELECTRICALS', icon: <Cable className="w-12 h-12 mb-2" />, products: 30 },
  // ];

  const featuredProducts = [
    { id: 1, name: 'Premium Solar Panel Kit', price: 599, rating: 4.8, reviews: 127 },
    { id: 2, name: 'Smart Inverter Pro', price: 899, rating: 4.9, reviews: 89 },
    { id: 3, name: 'Energy Storage System', price: 1299, rating: 4.7, reviews: 156 },
  ];

  
  const products = {
    'SOLAR PANELS': [
      {
        brand: 'JA SOLAR',
        name: 'JA SOLAR PANEL',
        image: ja,
        description: 'High-efficiency monocrystalline solar panel',
        category: 'SOLAR PANELS'
      },
      {
        brand: 'LONGI',
        name: 'LONGI SOLAR PANEL',
        image: longi,
        description: 'Premium performance solar modules',
        category: 'SOLAR PANELS'
      },
      {
        brand: 'TRINA SOLAR',
        name: 'TRINA SOLAR PANEL',
        image: trina,
        description: 'Advanced solar technology panel',
        category: 'SOLAR PANELS'
      },
      {
        brand: 'REC',
        name: 'REC SOLAR PANELS',
        image: rec,
        description: 'Cost-effective solar solution',
        category: 'SOLAR PANELS'
      },
      {
        brand: 'JINKO',
        name: 'JINKO SOLAR PANELS',
        image: jinko,
        description: 'Industry-leading solar panels',
        category: 'SOLAR PANELS'
      },
      {
        brand: 'CANADIAN',
        name: 'CANADIAN SOLAR PANELS',
        image: canadian,
        description: 'Industry-leading solar panels',
        category: 'SOLAR PANELS'
      },
      {
        brand: 'ASTRONERGY',
        name: 'ASTRONERGY SOLAR',
        image: astro,
        description: 'High-quality solar modules',
        category: 'SOLAR PANELS'
      }
    ],
    'SOLAR INVERTERS': [
      {
        brand: 'SOLIS',
        name: 'SOLIS INVERTER',
        image: solis,
        description: 'One of the worlds largest and most experienced manufacturers',
        category: 'SOLAR INVERTERS'
      },
      {
        brand: 'GOODWE',
        name: 'GOODWE INVERTER',
        image: goodwe,
        description: 'Specializing in residential and commercial solar inverters',
        category: 'SOLAR INVERTERS'
      },
      {
        brand: 'SUNGROW',
        name: 'SUNGROW INVERTER',
        image: sungrow,
        description: 'High-efficiency',
        category: 'SOLAR INVERTERS'
      },
      {
        brand: 'FRONIUS',
        name: 'FRONIUS INVERTER',
        image: fronius,
        description: 'High-energy conversion efficiency',
        category: 'SOLAR INVERTERS'
      },
    ],
    'SOLAR BATTERY': [
      
    ],
    'MOUNTING KIT': [
      {
        brand: 'ANTAI',
        name: 'ANTAI',
        image: antai,
        description: 'Reliable, and innovative solar mounting systems',
        category: 'MOUNTING KIT'
      },
      {
        brand: 'MIBET ENERGY',
        name: 'MIBET',
        image: mibet,
        description: 'World-class solar pv mounting system solution',
        category: 'MOUNTING KIT'
      },
    ],
   
  };


  const activeProducts = useMemo(() => {
    return products[activeCategory] || [];
  }, [activeCategory]);


  return (
    <div className="min-h-screen bg-green-50">
      {/* Enhanced Header */}
  <Header />
   
      {/* Hero Section */}
      <motion.section 
        className="relative pt-32 pb-48"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >

        <div 
          className="absolute inset-0 bg-gradient-to-r from-green-900/90 to-gray-900/80"
          style={{
            backgroundImage: `url(${bannerImg})`,
            backgroundSize: 'cover',
            backgroundAttachment: 'fixed',
          }}
        />
                  <div className="absolute inset-0 bg-gradient-to-r from-black to-black opacity-70"></div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-left space-y-8">
            <motion.h1 
              className="text-6xl text-center font-bold bg-gradient-to-r from-green-500 to-green-300 bg-clip-text text-transparent leading-tight"
              initial={{ y: 50 }}
              animate={{ y: 0 }}
            >
              Solar Energy Solutions<br />
              <span className="text-5xl font-medium">For a Sustainable Future</span>
            </motion.h1>
            <motion.p>
            <p className="text-lg text-center text-white md:text-xl max-w-3xl mx-auto font-body leading-relaxed">
            Dedicated to providing sustainable, cost-effective solar energy solutions for homes and businesses. With our high-quality solar panels and expert installation services, we help reduce energy costs while minimizing your carbon footprint            </p>
            </motion.p>
            {/* <div className="flex space-x-6">
              <motion.button
                className="px-8 py-4 bg-green-600 text-white rounded-xl hover:bg-green-700 shadow-lg hover:shadow-green-200/40 transition-all"
                whileHover={{ y: -2 }}
              >
                Explore Products
              </motion.button>
              <motion.button
                className="px-8 py-4 border-2 border-green-600 text-green-600 rounded-xl hover:bg-green-600/10 transition-all"
                whileHover={{ y: -2 }}
              >
                Watch Demo
              </motion.button>
            </div> */}
          </div>
        </div>
      </motion.section>

    


    

{/* Modern Category Cards */}
<section className="py-20">
        <div className="max-w-8xl mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6">
            {categories.map((category) => (
              <motion.div
                key={category.name}
                className={`group relative overflow-hidden rounded-2xl bg-white shadow-xl hover:shadow-2xl cursor-pointer transition-all ${activeCategory === category.name ? 'ring-2 ring-green-500' : ''}`}
                whileHover={{ y: -10 }}
                onClick={() => setActiveCategory(category.name)}
              >
                <div className="p-8 text-center">
                  <div className="mb-6 inline-block p-4 rounded-2xl bg-green-100/50">
                    {category.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800">{category.name}</h3>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>


      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    

      {/* Products Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {activeProducts.map((product, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
          >
            <div className="relative aspect-square bg-white">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-full object-contain p-4"
              />
              {/* <div className="absolute top-4 left-4">
                <img
                  src={product.image}
                  alt={product.brand}
                  className="h-8 w-auto"
                />
              </div> */}
            </div>
            <div className="p-4 bg-green-50 text-center">
              <h3 className="text-lg font-semibold text-green-900 mb-2">
                {product.name}
              </h3>
              <p className="text-sm text-gray-600 mb-4">
                {product.description}
              </p>
              {/* <button className="w-full bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 transition-colors">
                View Details
              </button> */}
            </div>
          </div>
        ))}
      </div>
    </div>

    {/* Categories Grid */}
    {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          {categories.map((category) => (
            <motion.button
              key={category.name}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => setActiveCategory(
                activeCategory === category.name ? null : category.name
              )}
              className={`flex flex-col items-center justify-center p-6 rounded-xl transition-all duration-300 ${
                activeCategory === category.name
                  ? 'bg-green-600 text-white shadow-lg'
                  : 'bg-white text-gray-600 hover:shadow-md'
              }`}
            >
              {category.icon}
              <span className="text-sm font-medium text-center mb-2">
                {category.name}
              </span>
              <span className="text-xs opacity-75">
                {category.products} Products
              </span>
            </motion.button>
          ))}
        </div>
      </div> */}

      {/* Dynamic Services Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <AnimatePresence mode='wait'>
            <motion.div
              key={activeCategory || 'default'}
              initial="initial"
              animate="animate"
              exit="exit"
              variants={fadeInVariants}
              transition={{ duration: 0.3 }}
            >
              <div className="text-center mb-12">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">
                  {activeCategory ? `SERVICES` : "OUR SERVICES"}
                </h2>
                <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                  {activeCategory 
                    ? `Premium ${activeCategory.toLowerCase()} solutions and services`
                    : "Krikosh is a rapidly expanding nation wide wholesaler specializing in renewable energy solutions."}
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {servicesToDisplay.map((service, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: index * 0.1 }}
                    className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
                  >
                    <div className="flex flex-col items-center text-center">
                      <div className="mb-4 p-3 bg-green-50 rounded-full">
                        {service.icon}
                      </div>
                      <h3 className="text-xl font-semibold text-gray-900 mb-4">
                        {service.title}
                      </h3>
                      <p className="text-gray-600">
                        {service.description}
                      </p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </section>

      {/* Dynamic Brands Section */}
      {/* <section className="py-16 bg-gray-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10 bg-gradient-to-br from-green-500 to-green-800" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <AnimatePresence mode='wait'>
            <motion.div
              key={activeCategory || 'default-brands'}
              initial="initial"
              animate="animate"
              exit="exit"
              variants={fadeInVariants}
              transition={{ duration: 0.3 }}
            >
              <div className="text-center mb-12">
                <h2 className="text-4xl font-bold text-white mb-4">
                  {activeCategory ? `${activeCategory} BRANDS` : "BRANDS WE SELL"}
                </h2>
                <p className="text-lg text-gray-300">
                  {activeCategory
                    ? `Trusted ${activeCategory.toLowerCase()} manufacturers`
                    : "We partner with industry-leading manufacturers"}
                </p>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
                {brandsToDisplay.map((brand) => (
                  <motion.div
                    key={brand.id}
                    whileHover={{ scale: 1.05 }}
                    className="bg-white rounded-lg p-6 flex items-center justify-center"
                  >
                    <img
                      src={brand.logo}
                      alt={brand.name}
                      className="max-h-12 w-auto"
                    />
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </section> */}

      {/* Categories */}
      {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 bg-primary-">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          {categories.map((category) => (
            <button
              key={category.name}
              onClick={() => setActiveCategory(category.name)}
              className={`flex flex-col items-center justify-center p-6 rounded-xl transition-all duration-300 transform hover:scale-105 ${
                activeCategory === category.name
                  ? 'bg-green-600 text-white shadow-lg'
                  : 'bg-white text-gray-600 hover:shadow-md'
              }`}
            >
              {category.icon}
              <span className="text-sm font-medium text-center mb-2">{category.name}</span>
              <span className="text-xs opacity-75">{category.products} Products</span>
            </button>
          ))}
        </div>
      </div> */}

          {/* Services Section */}
      {/* <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">OUR SERVICES</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Solmart is a rapidly expanding nation wide wholesaler specializing in a broad spectrum of renewable energy and energy efficiency products.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="mb-4 p-3 bg-green-50 rounded-full">
                    {service.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    {service.title}
                  </h3>
                  <p className="text-gray-600">
                    {service.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Brands Section */}
      {/* <section className="py-16 bg-gray-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-gradient-to-br from-green-500 to-green-800"></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-4">BRANDS WE SELL</h2>
            <p className="text-lg text-gray-300">
              We partner with industry-leading manufacturers to bring you the best solar solutions
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
            {brands.map((brand) => (
              <div 
                key={brand.id}
                className="bg-white rounded-lg p-6 flex items-center justify-center transform hover:scale-105 transition-transform duration-300"
              >
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="max-h-12 w-auto"
                />
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <button className="inline-flex items-center px-6 py-3 border-2 border-green-500 text-green-500 hover:bg-green-500 hover:text-white rounded-lg transition-colors duration-300">
              View All Brands
            </button>
          </div>
        </div>
      </section> */}


      {/* Featured Products */}
      {/* <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {activeProducts.map((product) => (
              <motion.div
                key={product.id}
                className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow overflow-hidden group"
                whileHover={{ scale: 1.02 }}
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900/40" />
                </div>
                <div className="p-6">
                  <h4 className="text-lg font-bold text-gray-900 mb-2">{product.name}</h4>
                  <div className="flex justify-between items-center">
                    <span className="text-2xl font-bold text-green-600">${product.price}</span>
                    <button className="p-2 bg-green-100 rounded-lg hover:bg-green-200 transition-colors">
                      <ShoppingCart className="h-5 w-5 text-green-600" />
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}
       <div className="bg-gradient-to-br from-green-600 to-green-700 text-black mx-auto px-4  sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="max-w-3xl">
            
            
          </div>
          <div className="grid md:grid-cols-3 gap-8">
        {/* Phone */}
        <div className="bg-gray-50 rounded-xl p-8 text-center shadow-lg">
          <div className="flex justify-center mb-4">
            <div className="p-3 bg-green-100 rounded-full">
              <Phone className="w-6 h-6 text-green-600" />
            </div>
          </div>
          <h3 className="text-xl font-semibold mb-2">Call Us</h3>
          <p className="text-gray-600 mb-4">Speak directly with our team</p>
          <a
            href="tel:0435574562"
            className="text-xl font-bold text-green-600 hover:text-green-700 mb-2"
          >
            0435 574 562
          </a>
          <br />
          <a
            href="tel:0468438722"
            className="text-xl font-bold text-green-600 hover:text-green-700"
          >
            0468 438 722
          </a>
        </div>

        {/* Email */}
        <div className="bg-gray-50 rounded-xl p-8 text-center shadow-lg">
          <div className="flex justify-center mb-4">
            <div className="p-3 bg-green-100 rounded-full">
              <Mail className="w-6 h-6 text-green-600" />
            </div>
          </div>
          <h3 className="text-xl font-semibold mb-2">Email Us</h3>
          <p className="text-gray-600 mb-4">Send us your inquiries</p>
          <a
            href="mailto:info@solmart.com.au"
            className="text-xl font-bold text-green-600 hover:text-green-700"
          >
            order@krikosh.com.au
          </a>
        </div>

        {/* Business Hours */}
        <div className="bg-gray-50 rounded-xl p-8 text-center shadow-lg">
          <div className="flex justify-center mb-4">
            <div className="p-3 bg-green-100 rounded-full">
              <Clock className="w-6 h-6 text-green-600" />
            </div>
          </div>
          <h3 className="text-xl font-semibold mb-2">Business Hours</h3>
          <p className="text-gray-600 mb-4">We're here to serve you</p>
          <div className="space-y-2">
            {businessHours.map((schedule, index) => (
              <div key={index} className="text-sm">
                <span className="font-medium">{schedule.day}: </span>
                <span className="text-gray-600">{schedule.hours}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
        </div>
      </div>

     
      <Footer />
    </div>

  );
};

export default HomePage;

